import React from 'react';
import * as Checkbox from '@radix-ui/react-checkbox';
import { twMerge } from 'tailwind-merge';
export const DaresFilterCheckbox = React.memo((props) => {
    return (<Checkbox.Root {...props} className="group border-[2px] active:scale-125 duration-150 rounded border-solid size-7 sm:size-5 border-white">
			<Checkbox.Indicator>
				<div className={twMerge('cursor-pointer w-full h-full bg-transparent rounded border-[2.5px] motion-safe:duration-150 border-black', props.checked && 'bg-light-4')}/>
			</Checkbox.Indicator>
		</Checkbox.Root>);
});
